import { isRejectedWithValue } from '@reduxjs/toolkit'
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'

interface ReduxAction {
  type: string
  payload?: any
  error?: any
}

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      console.warn('We got a rejected action!')
    }

    const reduxAction = action as ReduxAction
    if (reduxAction?.payload?.status === 499) {
      const redirectUrl = reduxAction.payload.data.headers.location
      window.location.href = redirectUrl
      return
    }

    return next(action)
  }
